module.exports = __webpack_public_path__ + "static/img/215_TO8_2160.813ff2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/215_TO8_2160.jpg
// module id = ADNn
// module chunks = 0